import { defineComponent } from 'vue'
import { numericProp } from '@xzx-design/utils'
import { useNamespace } from '@xzx-design/hooks'

import type { ExtractPropTypes } from 'vue'

export const DEFAULT_ROW_WIDTH = '100%'

export const skeletonParagraphProps = {
  round: Boolean,
  rowWidth: {
    type: numericProp,
    default: DEFAULT_ROW_WIDTH,
  },
}

export type SkeletonParagraphProps = ExtractPropTypes<
  typeof skeletonParagraphProps
>

const name = 'XzxSkeletonParagraph'

export default defineComponent({
  name,
  __name: name,
  props: skeletonParagraphProps,
  setup(props) {
    const { bem } = useNamespace('skeleton-paragraph')

    return () => (
      <div
        class={bem([{ round: props.round }])}
        style={{ width: props.rowWidth }}
      />
    )
  },
})
